import { t as throttle } from './throttle-CVAVDVkp.js';
import './debounce-CFN_LA0O.js';

/**
 * Page scroll progress bar. Height only — sticky offset is owned by announcement-bar.
 *
 * @element scroll-indicator
 */
class ScrollIndicator extends HTMLElement {
  /** @type {HTMLElement | null} */
  #footer = document.querySelector('.shopify-section--footer');

  /** @type {ResizeObserver | undefined} */
  #resizeObserver;

  connectedCallback() {
    this.#resizeObserver = new ResizeObserver(() => this.#measureHeight());
    this.#resizeObserver.observe(this);
    this.#measureHeight();

    window.addEventListener('scroll', this.#handleScroll, { passive: true });
    window.addEventListener('resize', this.#handleScroll, { passive: true });
    this.#updateProgress();
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    window.removeEventListener('scroll', this.#handleScroll);
    window.removeEventListener('resize', this.#handleScroll);
    this.#handleScroll.cancel();
  }

  #measureHeight() {
    document.documentElement.style.setProperty(
      '--scroll-indicator-height',
      `${this.offsetHeight}px`
    );
  }

  #updateProgress() {
    if (!this.#footer) return;

    const footerTop = this.#footer.getBoundingClientRect().top + window.scrollY;
    // clientHeight is stable when mobile browser chrome shows/hides; innerHeight is not.
    const maxScroll = Math.max(footerTop - document.documentElement.clientHeight, 1);
    const progress = Math.min(Math.max(window.scrollY / maxScroll, 0), 1);
    const percent = Math.round(progress * 100);

    this.style.setProperty('--scroll-indicator-progress', String(progress));
    this.setAttribute('aria-valuenow', String(percent));
  }

  /** Throttled so rapid mobile scroll events don't recalculate every tick. */
  #handleScroll = throttle(() => this.#updateProgress(), 16);
}

customElements.define('scroll-indicator', ScrollIndicator);
